import { createNamedAction } from 'helpers/ActionUtil'

import {
  OVERVIEW_UPDATE_STATE,
  OVERVIEW_ADD_MEMORY,
  OVERVIEW_REFRESH_MEMORY,
  UPDATE_STATE_ENTIRE_OBJ,
  OPEN_MEMORY_BROWSER_WITH_FILTER,
  TOGGLE_POPUP,
  TOGGLE_FILTER,
  INITIALIZE_FILTER,
  INITIALIZE_CONFIG,
  UPDATE_CONFIG_SELECTION,
  UPDATE_CONFIG_SOURCE,
  ADD_CONFIG,
  DELETE_PART,
  UPDATE_CURRENT_CONFIG,
  REFRESH_FILTER,
  ARCH,
  BRAND,
  CLASSIFICATION,
  UPDATE_CONFIG_MODEL_NAME,
} from './constants'

export const overviewUpdateState = (state, newValue) => {
  return {
    type: OVERVIEW_UPDATE_STATE,
    state,
    newValue
  }
}

export const addMemory = () => {
  return {
    type: OVERVIEW_ADD_MEMORY
  }
}

export const refreshMemory = () => {
  return {
    type: OVERVIEW_REFRESH_MEMORY
  }
}

export const updateStateEntireObj = (stateList, valueObj) => {
  return {
    type: UPDATE_STATE_ENTIRE_OBJ,
    stateList,
    valueObj
  }
}

export const openMemoryBrowserWithFilter = (categoryKey) => {
  return {
    type: OPEN_MEMORY_BROWSER_WITH_FILTER,
    categoryKey
  }
}

export const addConfig = (configs) => {
  return {
    type: ADD_CONFIG,
    configs,
  }
}

export const updateConfigModelName = (index, modelName) => {
  return {
    type: UPDATE_CONFIG_MODEL_NAME,
    index,
    modelName
  }
}

export const deletePart = (index) => {
  return {
    type: DELETE_PART,
    index
  }
}

/*
  UI State Related
*/

export const togglePopup = () => {
  return {
    type: TOGGLE_POPUP,
  }
}

export const updateConfigSelection = (newConfig) => {
  return {
    type: UPDATE_CONFIG_SELECTION,
    newConfig
  }
}

export const updateConfigSource = (newConfig) => {
  return {
    type: UPDATE_CONFIG_SOURCE,
    newConfig
  }
}

export const updateCurConfig = (curConfig) => {
  return {
    type: UPDATE_CURRENT_CONFIG,
    curConfig
  }
}

const initFilter = (filters) => {
  return {
    type: INITIALIZE_FILTER,
    filters,
  }
}

const updateFilter = (index, value) => {
  return {
    type: TOGGLE_FILTER,
    index,
    value
  }
}

const refreshFilter = () => {
  return {
    type: REFRESH_FILTER
  }
}

export const getUiActions = (uiPath) => {
  const createToggleAction = (type) => {
    return createNamedAction(type + uiPath, updateFilter)
  }
  const createInitAction = (type) => {
    return createNamedAction(type + uiPath, initFilter)
  }
  const createRefreshAction = (type) => {
    return createNamedAction(type + uiPath, refreshFilter)
  }
  const createInitFilterAction = (filters, curConfig) => {
    const initArch = createInitAction(ARCH)
    const initBrand = createInitAction(BRAND)
    const initClass = createInitAction(CLASSIFICATION)

    return () => {
      return (dispatch) => {
        dispatch(initArch(filters.architechture))
        dispatch(initBrand(filters.brand))
        dispatch(initClass(filters.classification))
      }
    }
  }
  const createRefreshFilterAction = () => {
    const refreshArch = createRefreshAction(ARCH)
    const refreshBrand = createRefreshAction(BRAND)
    const refreshClass = createRefreshAction(CLASSIFICATION)

    return () => {
      return dispatch => {
        dispatch(refreshArch())
        dispatch(refreshBrand())
        dispatch(refreshClass())
      }
    }
  }

  return {
    toggleArch: createToggleAction(ARCH),
    toggleBrand: createToggleAction(BRAND),
    toggleClass: createToggleAction(CLASSIFICATION),
    initFilters: createInitFilterAction,
    refreshFilters: createRefreshFilterAction(),
  }
}
